import { UPDATE_LOCALE } from './constants'
import { type ILanguageProviderState, type UpdateLocaleAction } from './types'

export const updateLocale = (locale: {
  locale: ILanguageProviderState['locale']
  fullLocale: ILanguageProviderState['fullLocale']
}): UpdateLocaleAction => ({ type: UPDATE_LOCALE, locale })
